import { render, staticRenderFns } from "./PhoneInput.vue?vue&type=template&id=226b557a&scoped=true"
import script from "./PhoneInput.vue?vue&type=script&lang=ts"
export * from "./PhoneInput.vue?vue&type=script&lang=ts"
import style0 from "./PhoneInput.vue?vue&type=style&index=0&id=226b557a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226b557a",
  null
  
)

export default component.exports